// extracted by mini-css-extract-plugin
export default {"cell":"cell_cell__oZ7Wn","winner":"cell_winner__GW9Ri"};